import { render } from "./TemaMiljosertifisering.vue?vue&type=template&id=05be41ad"
import script from "./TemaMiljosertifisering.vue?vue&type=script&lang=js"
export * from "./TemaMiljosertifisering.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__